import {Component, computed, inject, input} from '@angular/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {TodoPrioritySelect} from '../../../../../api';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {FormControl} from '@angular/forms';
import {TodoPriorityResource} from '../../../../../api/resources';

@Component({
  selector: 'elcia-todo-priority-dropdown',
  imports: [
    Dropdown,
    MultiDropdown,
    TranslatePipe
  ],
  templateUrl: './todo-priority-dropdown.html',
  styleUrl: './todo-priority-dropdown.scss',
})
export class TodoPriorityDropdown {
  translateService = inject(TranslateService);
  priorityResource = inject(TodoPriorityResource).getTodoPriorities();
  priorities = computed<TodoPrioritySelect[]>(() => {
    const values = this.priorityResource.value()?.todoPriorities?.map((t) => ({
      ...t,
      name: this.translateService.instant('todo-priority.' + t.name),
    } as TodoPrioritySelect)) || []
    return values.orderBy(v => v.name)
  });
  control = input.required<FormControl>();
  isMulti = input<boolean>(false);

}

